import { TicketCardShimmer } from "./TicketCardShimmer";

interface TicketListingShimmerProps {
  cardCount?: number;
}

const shimmerGradient =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] animate-pulse";

export const TicketListingShimmer = ({
  cardCount = 3,
}: TicketListingShimmerProps) => {
  return (
    <div className="flex flex-col min-w-[300px] max-w-[300px] px-2 pb-2 rounded-t-lg border-t border-x border-border-gray dark:border-border-gray-dk bg-(--color-gray-50) dark:bg-(--color-gray-50-dk)">
      {/* Stage header pill */}
      <div className="py-2">
        <div className={`h-[30px] w-[120px] rounded-lg ${shimmerGradient}`} />
      </div>

      {/* Shimmer cards */}
      <div className="flex flex-col gap-2">
        {Array.from({ length: cardCount })?.map((_, i) => (
          <TicketCardShimmer key={i} />
        ))}
      </div>
    </div>
  );
};
